import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { rgba } from 'polished';
import { noop } from 'lodash/noop';

import { SuiLabel, SuiField } from '@splashthat/sui';
import { createSuiTheme } from '@splashthat/sui/lib/theme';

import ColorPickerPopover from './ColorPickerPopover';

import './styles.styl';

const TRANSPARENT_COLOR = {
    name: 'transparent',
    value: /rgba\([0-9]*, [0-9]*, [0-9]*, 0\)/,
    style: {
        background: 'url("https://d24wuq6o951i2g.cloudfront.net/img/transparent.png")',
        backgroundSize: '80px',
        borderColor: rgba(createSuiTheme().palette.grayscale.black, 0),
    },
};

const BASE_CLASS_NAME = 'ColorPicker';

export default class ColorPicker extends Component {
    static propTypes = {
        color: PropTypes.shape({
            id: PropTypes.number,
            value: PropTypes.string,
        }).isRequired,
        label: PropTypes.string,
        'aria-label': PropTypes.string,
        changeColor: PropTypes.func.isRequired,
        colorList: PropTypes.array,
        getAnchorEl: PropTypes.func,
        getRefWidth: PropTypes.func,
        qaId: PropTypes.string.isRequired,
    };

    static defaultProps = {
        label: '',
        'aria-label': undefined,
        showPopover: noop,
        colorList: [],
        getAnchorEl: noop,
        getRefWidth: noop,
    };

    state = {
        popoverIsVisible: false,
    };

    showPopover = (e) => {
        e && e.stopPropagation();
        this.setState({
            popoverIsVisible: !this.state.popoverIsVisible,
        });
    };

    getBackgroundStyle = (color) =>
        color === TRANSPARENT_COLOR.name || TRANSPARENT_COLOR.value.test(color)
            ? TRANSPARENT_COLOR.style
            : {
                  backgroundColor: color,
              };

    showColorPickerPopover = () => (
        <ColorPickerPopover
            showPopover={this.state.popoverIsVisible}
            minWidth={this.props.getRefWidth()}
            colorList={this.props.colorList}
            anchorEl={this.props.getAnchorEl()}
            onClickClose={this.showPopover}
            onClickChangeColor={this.props.changeColor}
            colorPickerLabel={this.props.label}
            colorPickerColor={this.props.color}
            getBackgroundStyle={this.getBackgroundStyle}
            qaId={`${this.props.qaId}--popover`}
        />
    );

    render() {
        const { color, label, qaId, 'aria-label': ariaLabel } = this.props;
        const { popoverIsVisible } = this.state;
        const { value } = color;
        const colorSelectorAriaLabel = label ? `${label} ` : '';

        return (
            <React.Fragment>
                <SuiField
                    className={`${BASE_CLASS_NAME}__container`}
                    formElement={
                        <button
                            className={`${BASE_CLASS_NAME}__selector`}
                            onClick={this.showPopover}
                            data-qa={`${qaId}--picker`}
                            aria-label={ariaLabel || `${colorSelectorAriaLabel}Color Selection Button`}
                        >
                            <div
                                style={this.getBackgroundStyle(value)}
                                className={`${BASE_CLASS_NAME}__selector--color ${label ? 'labeled' : ''}`}
                            />
                            <SuiLabel text={label} className={`${BASE_CLASS_NAME}__selector--label`} />
                        </button>
                    }
                />
                {popoverIsVisible ? this.showColorPickerPopover() : null}
            </React.Fragment>
        );
    }
}
